var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEthereum = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.002 0-.004.007L9.994 0l-.007.026-6.124 10.16.006.004-.006.003 6.134 3.626v.003l.002-.002.003.002v-.003l6.134-3.626-.008-.003.005-.004L10.003.013V0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10.002 20-.004-.006-.004.006-.007-.021-6.124-8.63 6.135 3.624 6.14-3.624-6.136 8.64V20Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEthereum);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ethereum.838e4d0c955468743cadf44e40886fa4.svg";